import axios from 'axios';
import { handleError } from 'tradera/utils/api';

export const saveLanguageSetting = (code, toLocalizedUrl) =>
    axios
        .post(toLocalizedUrl('/my/profile/save-language-setting'), {
            languageCodeIso2: code,
        })
        .catch(handleError());

// Export object for Sinon stubbing
export default {
    saveLanguageSetting,
};
